export const PAAs = [
    {
        name: "Abigail Li",
        email: "al181@rice.edu",
        areaOfStudy: "Sports Medicine & Exercise Physiology; Spanish minor; Biochemistry & Cell Biology minor; Pre-Med",
        year: "Junior"
    },
    {
        name: "Arryana Lyon",
        email: "anl10@rice.edu",
        areaOfStudy: "Cognitive Sciences; Environmental Studies/French Language/Civic Leadership minors; Pre-Law, Pre-Graduate School",
        year: "Senior"
    },
    {
        name: "Mira Srinivasa",
        email: "mas50@rice.edu",
        areaOfStudy: "Bioengineering; Pre-Med",
        year: "Senior"
    },
    {
        name: "Jackson O'Brian",
        email: "jo60@rice.edu",
        areaOfStudy: "Mechanical Engineering; Pre-Med",
        year: "Sophomore"
    },
    {
        name: "Coleman O'Brian",
        email: "co63@rice.edu",
        areaOfStudy: "Mechanical Engineering; Pre-Law",
        year: "Sophomore"
    },
    {
        name: "Ben Schussler",
        email: "bns5@rice.edu",
        areaOfStudy: "Mathematics; Physics; Linguistics; Pre-Graduate School",
        year: "Junior"
    },
    {
        name: "Nyla Hartigan",
        email: "nrh1@rice.edu",
        areaOfStudy: "EEPS; Physics; Data Science minor; Pre-Graduate School",
        year: "Senior"
    },
    {
        name: "Hannah Watkins",
        email: "hw76@rice.edu",
        areaOfStudy: "Computer Science",
        year: "Senior"
    },
    {
        name: "Varsha Chandramouli",
        email: "vkc1@rice.edu",
        areaOfStudy: "Sports Medicine & Exercise Physiology; Spanish minor; Biochemistry & Cell Biology minor; Medical Humanities minor; Pre-Med",
        year: "Senior"
    },
    {
        name: "Lily Hestjean",
        email: "lh70@rice.edu",
        areaOfStudy: "Biosciences (Ecology and Evolutionary Biology); Spanish and Portuguese minor; Environmental Studies minor; Pre-Graduate School",
        year: "Sophomore"
    },
    {
        name: "Leslie Rojo Flores",
        email: "ls48@rice.edu",
        areaOfStudy: "Psychology; Sociology; Certificate in Language and Intercultural Communication - Spanish; Poverty, Justice, and Human Capabilities minor",
        year: "Sophomore"
    },
    {
        name: "Elena Wang",
        email: "ew76@rice.edu",
        areaOfStudy: "Physics; Data Science minor; Pre-Graduate School",
        year: "Sophomore"
    },
    {
        name: "Ava Brazell",
        email: "amb36@rice.edu",
        areaOfStudy: "Political Science major; Business minor; Pre-Law",
        year: "Junior"
    },
    {
        name: "Tori Cole",
        email: "tmc16@rice.edu",
        areaOfStudy: "Political Science; Sociology; African American Studies minor",
        year: "Junior"
    },
    {
        name: "Rachel Ayalon",
        email: "ra106@rice.edu",
        areaOfStudy: "Political Science; Social Policy Analysis; Spanish and Portuguese minor",
        year: "Sophomore"
    },
    {
        name: "Yilan Ruan",
        email: "yr23@rice.edu",
        areaOfStudy: "Mathematics; Computer Science; Pre-Graduate School",
        year: "SEnior"
    },
    {
        name: "Biraj Nainabasti",
        email: "bn25@rice.edu",
        areaOfStudy: "Sports Medicine; Biochemistry minor; Pre-Med",
        year: "Junior"
    },
    {
        name: "Naayaa Mehta",
        email: "nm80@rice.edu",
        areaOfStudy: "Bioengineering; Global Health Technologies minor; Pre-Graduate School",
        year: "Junior"
    }  
]